import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@msarat/theme/base.css';
import { App } from './App.jsx';

const container = document.getElementById('root');
if (!container) throw new Error('root element is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
